
import { Button, Grid2 } from '@mui/material'

import { useApartmentListForCourse, } from '../../assets/api/useAdminApi'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
// import api from '../../assets/api/useStudentPostApi'
import api from '../../assets/nodeApi/axiosInstance';
import useAuthStore from '../../store/useAuthStore'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { Grid_Gap } from '../../shared/constants';
import CustomDivider from '../../shared/utils/CustomDivider';
import useMarketingDetailStore from '../../store/useMarketingDetailStore';
import { useParams } from 'react-router-dom';
import { DateFormField } from '../../shared/components/formfields/DataFormField';

const AddMarketingForm = ({ handleCloseMarketing, ApartmentOption, isLoadingApart, inputWidth }) => {
  const { marketingDetail, clearMarketingDetail } = useMarketingDetailStore();
  const { id } = useParams()
  const selectedApartment = ApartmentOption?.find(item => item.id?.toString() === (id?.toString() ?? marketingDetail?.apartment_id?.toString()));
  const queryClient = useQueryClient();
  const gridWidth = inputWidth ?? 12
  const { token } = useAuthStore();
  const { showToaster } = useToaster();
  const mutation = useMutation({
    mutationFn: (formData) => {
      return marketingDetail?.id
        ? api.put(`marketing-ads/update/${marketingDetail?.id}`, formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        : api.post(`marketing-ads/create`, formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
    },
    onSuccess: (response) => {
      showToaster('Success', response?.data?.message, 'success');
      queryClient.invalidateQueries({ queryKey: ["marketing-ads"] });
      clearMarketingDetail()
    },
    onError: () => {
      showToaster("Error Caught While submiting the form", 'Error', 'error');
    },

  });
  const handleSubmitMarketing = (values, { setSubmitting, resetForm }) => {
    const obj = {
      ...values,
      apartment_id: Number(values.apartment_id || selectedApartment?.id),
      number_of_ads: Number(values.number_of_ads),
      ads_amount: Number(values.ads_amount)
    }
    mutation.mutate(obj, {
      onSettled: () => {
        setSubmitting(false);
      },
      onSuccess: () => {
        resetForm();
      }
    });
    handleCloseMarketing()
  }

  return (
    <Formik

      initialValues={{
        apartment_id: selectedApartment?.id || marketingDetail?.apartment_id || "",
        type_of_ads: marketingDetail?.type_of_ads || "",
        number_of_ads: marketingDetail?.number_of_ads || "",
        ads_amount: marketingDetail?.ads_amount || "",
        from_date: marketingDetail?.from_date || null,
        to_date: marketingDetail?.to_date || null,
      }}
      validationSchema={Yup.object().shape({
        apartment_id: Yup.string().required("Please Select Apartment"),
        type_of_ads: Yup.string().required("Ad type is required"),
        number_of_ads: Yup.number()
          .typeError("Must be a number")
          .required("Number of Ads is required")
          .min(1, "Must be at least 1"),
        ads_amount: Yup.number()
          .typeError("Must be a number")
          .required("Ad cost is required")
          .moreThan(0, "Must be greater than 0"),
        from_date: Yup.date().required("From date is required"),
        to_date: Yup.date().required("To date is required")

      })}
      onSubmit={handleSubmitMarketing}
      enableReinitialize={true}
    >
      {({ resetForm, values }) => (
        <Form>
          <Grid2 container spacing={"30px"}>
            <Grid2 children size={gridWidth}>
              <Field
                name="apartment_id"
                component={IdAutoCompleteField}
                options={ApartmentOption}
                label="Apartment"
                isRequired={true}
                isLoading={isLoadingApart}
                disabled={id}
              />
            </Grid2>
            <Grid2 children size={gridWidth}>
              <Field
                name="type_of_ads"
                component={TextFormField}
                label="Ad type"
                isRequired={true}
              />
            </Grid2>
            <Grid2 children size={gridWidth}>
              <Field
                name="number_of_ads"
                component={TextFormField}
                label="No Of Ads"
                isRequired={true}
                type="number"
              />
            </Grid2>
            <Grid2 children size={gridWidth}>
              <Field
                name="ads_amount"
                component={TextFormField}
                label="Cost"
                isRequired={true}
                type="number"
              />
            </Grid2>
            <Grid2 children size={gridWidth}>
              <Field
                name="from_date"
                component={DateFormField}
                label="From Date"
                isRequired={true}
                maxDate={values.to_date || undefined}
              />
            </Grid2>
            <Grid2 children size={gridWidth}>
              <Field
                name="to_date"
                component={DateFormField}
                label="To Date"
                isRequired={true}
                minDate={values.from_date || undefined}
              />
            </Grid2>

          </Grid2>
          <CustomDivider />
          <Grid2 container spacing={Grid_Gap}>
            <Grid2 children size={gridWidth} >
              <Button variant='outlined' fullWidth onClick={() => { resetForm(); clearMarketingDetail() }}>Cancel</Button>
            </Grid2>
            <Grid2 children size={gridWidth}>
              <Button variant='contained' fullWidth type="submit"> {Object.keys(marketingDetail).length === 0 ? "Submit" : "Update"}</Button>
            </Grid2>
          </Grid2>

        </Form>
      )}
    </Formik>
  )
}

export default AddMarketingForm